<template>
  <div class="projectProducts">
    <div>
      <div v-if="!editName" class="switchNormalProducts">列表類別: <span v-if="project.category">{{project.category}}</span><span v-else :style="{color:'#CACACA'}">請輸入類別名稱</span> <EditBtn @click="editName=true"/></div>
      <div v-else class="switchNormalProducts">列表類別:  <Input :defaultValue="cateName" @input="cateName=$event"/>
        <BtnsS @cancel="editName=false" @save="save({ category: cateName })"/></div>
      <div :style="{marginInline: 'auto'}"></div>
      <div class="switchNormalProducts">顯示常態販賣商品<switchVue :defaultValue="project.normalProducts" @update="save({ normalProducts: $event })"/></div>
      <div class="switchNormalProducts">使用專案活動商品<switchVue :defaultValue="project.specialMenu" @update="save({ specialMenu: $event })"/></div>
    </div>
    <cateList :categories="categories" :project="project"  class="List" :class="specialMenu ? '' : 'disabled'" @refresh="$emit('refresh')"/>
  </div>
</template>

<script>
// import ListBoxSingle from './singleList.vue'
import cateList from './cateList.vue'
import switchVue from '../../../components/radio/switch.vue'
import EditBtn from '../../../components/btn/edit.vue'
import Input from '../../../components/input/normal.vue'
import { postapi } from '../../../store/fetch'
export default {
  components: { switchVue, EditBtn, Input, cateList },
  props: ['project', 'categories'],
  data () {
    return {
      editName: false,
      cateName: null,
      select: false
    }
  },
  computed: {
    specialMenu () { return this.project.specialMenu }
  },
  methods: {
    async save (body) {
      const r = await postapi(`projects/${this.project._id}/base`, body)
      if (r) {
        this.$emit('refresh')
        this.editName = false
      }
    }
  }

}
</script>

<style lang="scss" scoped>
button.add {
  width: 30px;
  height: 30px;
  background-color: #FFFFFF;
  border-radius: 3px;
  mask-image: url(/svg/btn/plusSqr.svg);
  mask-size: 28px;
  mask-repeat: no-repeat;
  mask-position: center;
}
.List.disabled {
  filter: contrast(.5);
  background-color: #CACACA33;
  position: relative;
  z-index: 1;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
}
.projectProducts {
  display: grid;
  grid-template-rows: 70px 1fr;
  &>div:nth-child(1) {
    height: 70px;
    display: flex;
    align-items: center;
    padding-inline: 50px;
    gap: 30px;
    color: var(--color-pri);
    font-size: 24px;
    font-weight: 700;
    letter-spacing: .05em;
    border-bottom: 1px solid #CACACA;
  }
  &>div:nth-child(2) {
  }
}
.switchNormalProducts {
  display: flex;
  gap: 10px;
  color: var(--color-pri);
  font-size: 24px;
  font-weight: 700;
  letter-spacing: .05em;
}
</style>
